import SelectList from "types/SelectList";

const COUNTRY_LIST: SelectList = [
  { value: "AF", label: "Afghanistan (AF)" },
  { value: "ZA", label: "South Africa (ZA)" },
  { value: "AL", label: "Albania (AL)" },
  { value: "DE", label: "Germany (DE)" },
  { value: "AD", label: "Andorra (AD)" },
  { value: "AO", label: "Angola (AO)" },
  { value: "AI", label: "Anguilla (AI)" },
  { value: "AQ", label: "Antarctica (AQ)" },
  { value: "AG", label: "Antigua and Barbuda (AG)" },
  { value: "SA", label: "Saudi Arabia (SA)" },
  { value: "DZ", label: "Algeria (DZ)" },
  { value: "AR", label: "Argentina (AR)" },
  { value: "AM", label: "Armenia (AM)" },
  { value: "AW", label: "Aruba (AW)" },
  { value: "AU", label: "Australia (AU)" },
  { value: "AT", label: "Austria (AT)" },
  { value: "AZ", label: "Azerbaijan (AZ)" },
  { value: "BS", label: "Bahamas (BS)" },
  { value: "BH", label: "Bahrain (BH)" },
  { value: "BD", label: "Bangladesh (BD)" },
  { value: "BB", label: "Barbados (BB)" },
  { value: "BE", label: "Belgium (BE)" },
  { value: "BZ", label: "Belize (BZ)" },
  { value: "BJ", label: "Benin (BJ)" },
  { value: "BM", label: "Bermuda (BM)" },
  { value: "BY", label: "Belarus (BY)" },
  { value: "BO", label: "Bolivia (BO)" },
  { value: "BA", label: "Bosnia and Herzegovina (BA)" },
  { value: "BW", label: "Botswana (BW)" },
  { value: "BR", label: "Brazil (BR)" },
  { value: "BN", label: "Brunei (BN)" },
  { value: "BG", label: "Bulgaria (BG)" },
  { value: "BF", label: "Burkina Faso (BF)" },
  { value: "BI", label: "Burundi (BI)" },
  { value: "BT", label: "Bhutan (BT)" },
  { value: "CV", label: "Cape Verde (CV)" },
  { value: "CM", label: "Cameroon (CM)" },
  { value: "KH", label: "Cambodia (KH)" },
  { value: "CA", label: "Canada (CA)" },
  { value: "QA", label: "Qatar (QA)" },
  { value: "KZ", label: "Kazakhstan (KZ)" },
  { value: "TD", label: "Chad (TD)" },
  { value: "CL", label: "Chile (CL)" },
  { value: "CN", label: "China (CN)" },
  { value: "CY", label: "Cyprus (CY)" },
  { value: "VA", label: "Vatican City (VA)" },
  { value: "CO", label: "Colombia (CO)" },
  { value: "KM", label: "Comoros (KM)" },
  { value: "CG", label: "Republic of the Congo (CG)" },
  { value: "CD", label: "Democratic Republic of the Congo (CD)" },
  { value: "KP", label: "North Korea (KP)" },
  { value: "KR", label: "South Korea (KR)" },
  { value: "CI", label: "Ivory Coast (CI)" },
  { value: "CR", label: "Costa Rica (CR)" },
  { value: "HR", label: "Croatia (HR)" },
  { value: "CU", label: "Cuba (CU)" },
  { value: "DK", label: "Denmark (DK)" },
  { value: "DJ", label: "Djibouti (DJ)" },
  { value: "DM", label: "Dominica (DM)" },
  { value: "EG", label: "Egypt (EG)" },
  { value: "SV", label: "El Salvador (SV)" },
  { value: "AE", label: "United Arab Emirates (AE)" },
  { value: "EC", label: "Ecuador (EC)" },
  { value: "ER", label: "Eritrea (ER)" },
  { value: "SK", label: "Slovakia (SK)" },
  { value: "SI", label: "Slovenia (SI)" },
  { value: "ES", label: "Spain (ES)" },
  { value: "US", label: "United States (US)" },
  { value: "EE", label: "Estonia (EE)" },
  { value: "SZ", label: "Eswatini (SZ)" },
  { value: "ET", label: "Ethiopia (ET)" },
  { value: "FJ", label: "Fiji (FJ)" },
  { value: "PH", label: "Philippines (PH)" },
  { value: "FI", label: "Finland (FI)" },
  { value: "FR", label: "France (FR)" },
  { value: "GA", label: "Gabon (GA)" },
  { value: "GM", label: "Gambia (GM)" },
  { value: "GH", label: "Ghana (GH)" },
  { value: "GE", label: "Georgia (GE)" },
  { value: "GI", label: "Gibraltar (GI)" },
  { value: "GD", label: "Grenada (GD)" },
  { value: "GR", label: "Greece (GR)" },
  { value: "GL", label: "Greenland (GL)" },
  { value: "GP", label: "Guadeloupe (GP)" },
  { value: "GU", label: "Guam (GU)" },
  { value: "GT", label: "Guatemala (GT)" },
  { value: "GG", label: "Guernsey (GG)" },
  { value: "GY", label: "Guyana (GY)" },
  { value: "GF", label: "French Guiana (GF)" },
  { value: "GN", label: "Guinea (GN)" },
  { value: "GQ", label: "Equatorial Guinea (GQ)" },
  { value: "GW", label: "Guinea-Bissau (GW)" },
  { value: "HT", label: "Haiti (HT)" },
  { value: "NL", label: "Netherlands (NL)" },
  { value: "HN", label: "Honduras (HN)" },
  { value: "HK", label: "Hong Kong (HK)" },
  { value: "HU", label: "Hungary (HU)" },
  { value: "YE", label: "Yemen (YE)" },
  { value: "BV", label: "Bouvet Island (BV)" },
  { value: "CX", label: "Christmas Island (CX)" },
  { value: "IM", label: "Isle of Man (IM)" },
  { value: "NF", label: "Norfolk Island (NF)" },
  { value: "AX", label: "Åland Islands (AX)" },
  { value: "KY", label: "Cayman Islands (KY)" },
  { value: "CC", label: "Cocos Islands (CC)" },
  { value: "CK", label: "Cook Islands (CK)" },
  { value: "FO", label: "Faroe Islands (FO)" },
  { value: "GS", label: "South Georgia (GS)" },
  { value: "HM", label: "Heard Island (HM)" },
  { value: "FK", label: "Falkland Islands (FK)" },
  { value: "MP", label: "Northern Mariana Islands (MP)" },
  { value: "MH", label: "Marshall Islands (MH)" },
  { value: "UM", label: "U.S. Minor Outlying Islands (UM)" },
  { value: "PN", label: "Pitcairn (PN)" },
  { value: "SB", label: "Solomon Islands (SB)" },
  { value: "TC", label: "Turks and Caicos Islands (TC)" },
  { value: "VG", label: "British Virgin Islands (VG)" },
  { value: "VI", label: "U.S. Virgin Islands (VI)" },
  { value: "IN", label: "India (IN)" },
  { value: "ID", label: "Indonesia (ID)" },
  { value: "IR", label: "Iran (IR)" },
  { value: "IQ", label: "Iraq (IQ)" },
  { value: "IE", label: "Ireland (IE)" },
  { value: "IS", label: "Iceland (IS)" },
  { value: "IL", label: "Israel (IL)" },
  { value: "IT", label: "Italy (IT)" },
  { value: "JM", label: "Jamaica (JM)" },
  { value: "JP", label: "Japan (JP)" },
  { value: "JE", label: "Jersey (JE)" },
  { value: "JO", label: "Jordan (JO)" },
  { value: "KI", label: "Kiribati (KI)" },
  { value: "KW", label: "Kuwait (KW)" },
  { value: "LA", label: "Laos (LA)" },
  { value: "LS", label: "Lesotho (LS)" },
  { value: "LV", label: "Latvia (LV)" },
  { value: "LB", label: "Lebanon (LB)" },
  { value: "LR", label: "Liberia (LR)" },
  { value: "LY", label: "Libya (LY)" },
  { value: "LI", label: "Liechtenstein (LI)" },
  { value: "LT", label: "Lithuania (LT)" },
  { value: "LU", label: "Luxembourg (LU)" },
  { value: "MO", label: "Macao (MO)" },
  { value: "MK", label: "North Macedonia (MK)" },
  { value: "MG", label: "Madagascar (MG)" },
  { value: "MY", label: "Malaysia (MY)" },
  { value: "MW", label: "Malawi (MW)" },
  { value: "MV", label: "Maldives (MV)" },
  { value: "ML", label: "Mali (ML)" },
  { value: "MT", label: "Malta (MT)" },
  { value: "MA", label: "Morocco (MA)" },
  { value: "MQ", label: "Martinique (MQ)" },
  { value: "MU", label: "Mauritius (MU)" },
  { value: "MR", label: "Mauritania (MR)" },
  { value: "YT", label: "Mayotte (YT)" },
  { value: "MX", label: "Mexico (MX)" },
  { value: "FM", label: "Micronesia (FM)" },
  { value: "MZ", label: "Mozambique (MZ)" },
  { value: "MD", label: "Moldova (MD)" },
  { value: "MC", label: "Monaco (MC)" },
  { value: "MN", label: "Mongolia (MN)" },
  { value: "ME", label: "Montenegro (ME)" },
  { value: "MS", label: "Montserrat (MS)" },
  { value: "MM", label: "Myanmar (MM)" },
  { value: "NA", label: "Namibia (NA)" },
  { value: "NR", label: "Nauru (NR)" },
  { value: "NP", label: "Nepal (NP)" },
  { value: "NI", label: "Nicaragua (NI)" },
  { value: "NE", label: "Niger (NE)" },
  { value: "NG", label: "Nigeria (NG)" },
  { value: "NU", label: "Niue (NU)" },
  { value: "NO", label: "Norway (NO)" },
  { value: "NC", label: "New Caledonia (NC)" },
  { value: "NZ", label: "New Zealand (NZ)" },
  { value: "OM", label: "Oman (OM)" },
  { value: "PW", label: "Palau (PW)" },
  { value: "PA", label: "Panama (PA)" },
  { value: "PG", label: "Papua New Guinea (PG)" },
  { value: "PK", label: "Pakistan (PK)" },
  { value: "PY", label: "Paraguay (PY)" },
  { value: "PE", label: "Peru (PE)" },
  { value: "PF", label: "French Polynesia (PF)" },
  { value: "PL", label: "Poland (PL)" },
  { value: "PR", label: "Puerto Rico (PR)" },
  { value: "PT", label: "Portugal (PT)" },
  { value: "KE", label: "Kenya (KE)" },
  { value: "KG", label: "Kyrgyzstan (KG)" },
  { value: "CF", label: "Central African Republic (CF)" },
  { value: "DO", label: "Dominican Republic (DO)" },
  { value: "CZ", label: "Czech Republic (CZ)" },
  { value: "RE", label: "Réunion (RE)" },
  { value: "RO", label: "Romania (RO)" },
  { value: "RW", label: "Rwanda (RW)" },
  { value: "RU", label: "Russia (RU)" },
  { value: "EH", label: "Western Sahara (EH)" },
  { value: "WS", label: "Samoa (WS)" },
  { value: "AS", label: "American Samoa (AS)" },
  { value: "BL", label: "Saint Barthélemy (BL)" },
  { value: "KN", label: "Saint Kitts and Nevis (KN)" },
  { value: "SM", label: "San Marino (SM)" },
  { value: "MF", label: "Saint Martin (MF)" },
  { value: "PM", label: "Saint Pierre and Miquelon (PM)" },
  { value: "ST", label: "São Tomé and Príncipe (ST)" },
  { value: "VC", label: "Saint Vincent and the Grenadines (VC)" },
  { value: "SH", label: "Saint Helena (SH)" },
  { value: "LC", label: "Saint Lucia (LC)" },
  { value: "SN", label: "Senegal (SN)" },
  { value: "SL", label: "Sierra Leone (SL)" },
  { value: "RS", label: "Serbia (RS)" },
  { value: "SC", label: "Seychelles (SC)" },
  { value: "SG", label: "Singapore (SG)" },
  { value: "SY", label: "Syria (SY)" },
  { value: "SO", label: "Somalia (SO)" },
  { value: "LK", label: "Sri Lanka (LK)" },
  { value: "SD", label: "Sudan (SD)" },
  { value: "SS", label: "South Sudan (SS)" },
  { value: "SE", label: "Sweden (SE)" },
  { value: "CH", label: "Switzerland (CH)" },
  { value: "SR", label: "Suriname (SR)" },
  { value: "TH", label: "Thailand (TH)" },
  { value: "TW", label: "Taiwan (TW)" },
  { value: "TJ", label: "Tajikistan (TJ)" },
  { value: "TZ", label: "Tanzania (TZ)" },
  { value: "TF", label: "French Southern Territories (TF)" },
  { value: "IO", label: "British Indian Ocean Territory (IO)" },
  { value: "PS", label: "Palestine (PS)" },
  { value: "TL", label: "Timor-Leste (TL)" },
  { value: "TG", label: "Togo (TG)" },
  { value: "TK", label: "Tokelau (TK)" },
  { value: "TO", label: "Tonga (TO)" },
  { value: "TT", label: "Trinidad and Tobago (TT)" },
  { value: "TN", label: "Tunisia (TN)" },
  { value: "TM", label: "Turkmenistan (TM)" },
  { value: "TR", label: "Turkey (TR)" },
  { value: "TV", label: "Tuvalu (TV)" },
  { value: "UA", label: "Ukraine (UA)" },
  { value: "UG", label: "Uganda (UG)" },
  { value: "UY", label: "Uruguay (UY)" },
  { value: "UZ", label: "Uzbekistan (UZ)" },
  { value: "VU", label: "Vanuatu (VU)" },
  { value: "VE", label: "Venezuela (VE)" },
  { value: "VN", label: "Vietnam (VN)" },
  { value: "WF", label: "Wallis and Futuna (WF)" },
  { value: "ZM", label: "Zambia (ZM)" },
  { value: "ZW", label: "Zimbabwe (ZW)" },
];

export default COUNTRY_LIST;
